import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "capability-humaneness-chart" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = { class: "bg-blue-50 border-l-4 border-blue-600 pa-4 rounded-r-lg mb-4" }
const _hoisted_4 = { class: "text-body-2 mb-2" }
const _hoisted_5 = { class: "text-body-2" }
const _hoisted_6 = { class: "chart-container" }
const _hoisted_7 = ["viewBox"]
const _hoisted_8 = { class: "grid-lines" }
const _hoisted_9 = ["x1", "y1", "x2", "y2"]
const _hoisted_10 = ["x1", "y1", "x2", "y2"]
const _hoisted_11 = ["x1", "y1", "x2", "y2"]
const _hoisted_12 = { class: "data-points" }
const _hoisted_13 = ["onMouseenter"]
const _hoisted_14 = ["cx", "cy", "fill", "stroke"]
const _hoisted_15 = ["x", "y", "fill"]
const _hoisted_16 = { class: "axes" }
const _hoisted_17 = ["x1", "y1", "x2", "y2"]
const _hoisted_18 = ["x1", "y1", "x2", "y2"]
const _hoisted_19 = { class: "axis-labels" }
const _hoisted_20 = ["x", "y"]
const _hoisted_21 = ["x", "y"]
const _hoisted_22 = ["x", "y"]
const _hoisted_23 = ["y", "transform"]
const _hoisted_24 = { class: "text-h6 font-weight-bold mb-2" }
const _hoisted_25 = { class: "text-body-2" }
const _hoisted_26 = { class: "mt-2" }
const _hoisted_27 = { class: "mt-8" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-md-6 mb-4" }
const _hoisted_30 = { class: "col-md-6 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "text-h4 font-weight-bold mb-2" }, "Capability vs. Humaneness: The Data Shows They Go Together", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-body-1 mb-4" }, [
        _createTextVNode(" There's a common belief that prioritizing human wellbeing means sacrificing capability. "),
        _createElementVNode("strong", null, "The data proves otherwise:"),
        _createTextVNode(" The newest, most capable models are also the most humane. ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, [
          _createElementVNode("strong", null, "Correlation Coefficient: " + _toDisplayString(_ctx.correlation.toFixed(3)), 1)
        ]),
        _createElementVNode("p", _hoisted_5, " This strong positive correlation (r = " + _toDisplayString(_ctx.correlation.toFixed(3)) + ") shows that more capable models consistently score higher on humane principles. The top performers on standard benchmarks (MMLU, GPQA, HumanEval) are also the top performers on HumaneBench. ", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(), _createElementBlock("svg", {
        viewBox: `0 0 ${_ctx.svgWidth} ${_ctx.svgHeight}`,
        width: "100%",
        class: "chart-svg"
      }, [
        _createElementVNode("g", _hoisted_8, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
            return _createElementVNode("line", {
              key: `h-${i}`,
              x1: _ctx.padding,
              y1: _ctx.padding + (i - 1) * (_ctx.chartHeight / 4),
              x2: _ctx.svgWidth - _ctx.padding,
              y2: _ctx.padding + (i - 1) * (_ctx.chartHeight / 4),
              stroke: "#e0e0e0",
              "stroke-width": "1",
              "stroke-dasharray": "2,2"
            }, null, 8, _hoisted_9)
          }), 64)),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
            return _createElementVNode("line", {
              key: `v-${i}`,
              x1: _ctx.padding + (i - 1) * (_ctx.chartWidth / 4),
              y1: _ctx.padding,
              x2: _ctx.padding + (i - 1) * (_ctx.chartWidth / 4),
              y2: _ctx.svgHeight - _ctx.padding,
              stroke: "#e0e0e0",
              "stroke-width": "1",
              "stroke-dasharray": "2,2"
            }, null, 8, _hoisted_10)
          }), 64))
        ]),
        _createElementVNode("line", {
          x1: _ctx.padding,
          y1: _ctx.getY(0),
          x2: _ctx.svgWidth - _ctx.padding,
          y2: _ctx.getY(1),
          stroke: "#3b82f6",
          "stroke-width": "2",
          "stroke-dasharray": "4,4",
          opacity: "0.5"
        }, null, 8, _hoisted_11),
        _createElementVNode("g", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedModels, (model) => {
            return (_openBlock(), _createElementBlock("g", {
              key: model.model,
              class: "data-point",
              onMouseenter: ($event: any) => (_ctx.showTooltip(model, $event)),
              onMouseleave: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideTooltip && _ctx.hideTooltip(...args)))
            }, [
              _createElementVNode("circle", {
                cx: _ctx.getX(model.averageCapability),
                cy: _ctx.getY(model.humaneScore),
                r: 8,
                fill: _ctx.getPointColor(model.humaneScore),
                stroke: _ctx.getPointColor(model.humaneScore),
                "stroke-width": "2",
                class: _normalizeClass(["cursor-pointer", { 'hover:opacity-80': true }])
              }, null, 8, _hoisted_14),
              (model.humaneScore > 0.7 || model.averageCapability > 75)
                ? (_openBlock(), _createElementBlock("text", {
                    key: 0,
                    x: _ctx.getX(model.averageCapability),
                    y: _ctx.getY(model.humaneScore) - 12,
                    "text-anchor": "middle",
                    class: "text-caption font-weight-medium",
                    fill: _ctx.getPointColor(model.humaneScore)
                  }, _toDisplayString(_ctx.getShortModelName(model.model)), 9, _hoisted_15))
                : _createCommentVNode("", true)
            ], 40, _hoisted_13))
          }), 128))
        ]),
        _createElementVNode("g", _hoisted_16, [
          _createElementVNode("line", {
            x1: _ctx.padding,
            y1: _ctx.svgHeight - _ctx.padding,
            x2: _ctx.svgWidth - _ctx.padding,
            y2: _ctx.svgHeight - _ctx.padding,
            stroke: "#333",
            "stroke-width": "2"
          }, null, 8, _hoisted_17),
          _createElementVNode("line", {
            x1: _ctx.padding,
            y1: _ctx.padding,
            x2: _ctx.padding,
            y2: _ctx.svgHeight - _ctx.padding,
            stroke: "#333",
            "stroke-width": "2"
          }, null, 8, _hoisted_18)
        ]),
        _createElementVNode("g", _hoisted_19, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
            return _createElementVNode("text", {
              key: `x-label-${i}`,
              x: _ctx.padding + (i - 1) * (_ctx.chartWidth / 4),
              y: _ctx.svgHeight - _ctx.padding + 20,
              "text-anchor": "middle",
              class: "text-caption font-weight-medium"
            }, _toDisplayString(Math.round(_ctx.minCapability + (i - 1) * (_ctx.maxCapability - _ctx.minCapability) / 4)), 9, _hoisted_20)
          }), 64)),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
            return _createElementVNode("text", {
              key: `y-label-${i}`,
              x: _ctx.padding - 10,
              y: _ctx.padding + (i - 1) * (_ctx.chartHeight / 4) + 4,
              "text-anchor": "end",
              class: "text-caption font-weight-medium"
            }, _toDisplayString((1 - (i - 1) * 0.25).toFixed(2)), 9, _hoisted_21)
          }), 64))
        ]),
        _createElementVNode("text", {
          x: _ctx.svgWidth / 2,
          y: _ctx.svgHeight - 10,
          "text-anchor": "middle",
          class: "text-body-2 font-weight-bold"
        }, " Average Capability Score (MMLU, GPQA, HumanEval) ", 8, _hoisted_22),
        _createElementVNode("text", {
          x: 20,
          y: _ctx.svgHeight / 2,
          "text-anchor": "middle",
          class: "text-body-2 font-weight-bold",
          transform: `rotate(-90, 20, ${_ctx.svgHeight / 2})`
        }, " HumaneScore ", 8, _hoisted_23)
      ], 8, _hoisted_7))
    ]),
    (_ctx.tooltipVisible && _ctx.tooltipData)
      ? (_openBlock(), _createBlock(_component_v_card, {
          key: 0,
          class: "position-fixed elevation-8 rounded-lg pa-4 bg-white",
          style: _normalizeStyle(_ctx.tooltipStyle)
        }, {
          default: _withCtx(() => [
            _createElementVNode("h3", _hoisted_24, _toDisplayString(_ctx.tooltipData.model), 1),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("p", null, [
                _cache[3] || (_cache[3] = _createElementVNode("strong", null, "HumaneScore:", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.tooltipData.humaneScore.toFixed(2)), 1)
              ]),
              _createElementVNode("p", null, [
                _cache[4] || (_cache[4] = _createElementVNode("strong", null, "Average Capability:", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.tooltipData.averageCapability.toFixed(1)), 1)
              ]),
              _createElementVNode("p", _hoisted_26, [
                _cache[5] || (_cache[5] = _createElementVNode("strong", null, "MMLU:", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.tooltipData.mmlu.toFixed(1)), 1)
              ]),
              _createElementVNode("p", null, [
                _cache[6] || (_cache[6] = _createElementVNode("strong", null, "GPQA:", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.tooltipData.gpqa.toFixed(1)), 1)
              ]),
              _createElementVNode("p", null, [
                _cache[7] || (_cache[7] = _createElementVNode("strong", null, "HumanEval:", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.tooltipData.humanEval.toFixed(1)), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["style"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_27, [
      _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "text-h5 font-weight-bold mb-4" }, "Key Insights", -1)),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_v_card, {
            class: "pa-4",
            elevation: "2"
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createElementVNode("h4", { class: "text-h6 font-weight-bold mb-2" }, "Top Performers", -1),
              _createElementVNode("p", { class: "text-body-2" }, " The three highest-capability models (GPT-5, Gemini 3 Pro, Claude Sonnet 4.5) all score above 0.75 on HumaneScore, demonstrating that cutting-edge capability and humaneness are not trade-offs. ", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_v_card, {
            class: "pa-4",
            elevation: "2"
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createElementVNode("h4", { class: "text-h6 font-weight-bold mb-2" }, "The Pattern", -1),
              _createElementVNode("p", { class: "text-body-2" }, " Models that excel on standard benchmarks (MMLU, GPQA, HumanEval) consistently perform better on humane principles. This suggests that building more capable models creates opportunities for better safety and alignment. ", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}